export default __webpack_public_path__ + "static/abdelmoghit-idhsaine-resume-05364f402916ca1a2c3c481d6e428e85.pdf";